import { PropsWithChildren } from 'react';
import { windowMaxWidth } from '../../_layouts/consts';

export default function AlertPage({ children }: PropsWithChildren) {
  return (
    <div id="alert-page" className="flex min-h-full flex-1 flex-col justify-center">
      <div className={'mx-auto w-full p-4 flex flex-1 flex-col m-6 bg-white rounded-2xl ' + windowMaxWidth}>
        <h3 className="text-red-500">{children}</h3>
      </div>
    </div>
  );
}
